module.exports = __webpack_public_path__ + "hyperion-v2-static/img/resources_dashboard1.c399ca40.png";